import * as enumModels from '../Models/EnumModels';
import { EntityCodes } from '../Models/EnumModels';

export class MetaDataCache {
    public MasterDataType: enumModels.MasterDataTypes;
    public Data: any;
}

export class TopFilterStatModel<T = string> {
    public Id: T;   
    public IconClass: string;
    public Label: string;
    public Value: number;

}

export class SearchTextResult {
    public Term: string;
    public ItemCount: number;
    public Entity: EntityCodes;
    public EntityName: string;
}





